import { motion, useReducedMotion } from "framer-motion";
import { asset } from "@/lib/assets";

const AnimatedLogo = ({ className = "" }) => {
  const reduce = useReducedMotion();

  if (reduce) {
    return (
      <img src={asset("/assets/ui/snapx-logo.webp")} alt="SNAPX TECHNOLOGIES LLP" width={539} height={168} className={`h-11 w-auto md:h-14 ${className}`} />
    );
  }

  return (
    <span className={`flex items-center gap-2.5 ${className}`} data-testid="animated-logo">
      <span className="relative inline-flex">
        <motion.img
          src={asset("/assets/ui/snapx-mark.webp")}
          alt=""
          width={336}
          height={336}
          className="h-11 w-11 md:h-14 md:w-14"
          initial={{ scale: 0, rotate: -140, opacity: 0 }}
          animate={{ scale: [0, 1.15, 1], rotate: 0, opacity: 1 }}
          transition={{ duration: 0.9, times: [0, 0.7, 1], delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
          whileHover={{ rotate: 25 }}
        />
      </span>
      <span className="overflow-hidden py-0.5">
        <motion.img
          src={asset("/assets/ui/snapx-wordmark.webp")}
          alt="SNAPX TECHNOLOGIES LLP"
          width={525}
          height={120}
          className="h-8 w-auto md:h-10"
          initial={{ y: "120%", opacity: 0 }}
          animate={{ y: "0%", opacity: 1 }}
          transition={{ duration: 0.85, delay: 0.5, ease: [0.22, 1, 0.36, 1] }}
        />
      </span>
    </span>
  );
};

export default AnimatedLogo;
